require('./RASuitabilityTestFailureDisclaimer.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @common
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

//@components
const RASuitabilityTestFailureDisclaimerModal = require('../RASuitabilityTestFailureDisclaimerModal/RASuitabilityTestFailureDisclaimerModal');

// @utilites
const { FormattedText, formatText } = require('core/i18n').i18n;

const {
    MYPROFILE_BROKER_ROBO_URL,
    MYPROFILE_BROKER_GENERAL_URL,
} = require('../../raConstants/index');
class RASuitabilityTestFailureDisclaimer extends React.Component {
    constructor(props) {
        super(props);
        this.handleReviseSuitabilityTest = this.handleReviseSuitabilityTest.bind(
            this,
        );
        this.handleSecondaryButton = this.handleSecondaryButton.bind(this);
        this.handleContinueWithUnsuccessTest = this.handleContinueWithUnsuccessTest.bind(
            this,
        );
    }

    handleSecondaryButton() {
        const { hasRoboPortfolio, history } = this.props;
        if (hasRoboPortfolio) {
            history.push(MYPROFILE_BROKER_ROBO_URL);
        } else {
            history.push(MYPROFILE_BROKER_GENERAL_URL);
        }
    }

    handleContinueWithUnsuccessTest() {
        const { continueWithUnsuccess } = this.props;
        continueWithUnsuccess();
    }

    handleReviseSuitabilityTest() {
        const { isReviewInProgress, resetTestCompleted } = this.props;
        resetTestCompleted();
        isReviewInProgress();
    }

    buildContent() {
        const { hasRoboPortfolio } = this.props;
        let content;
        if (__CONTACT_CENTER__) {
            const firstParagraphCC = hasRoboPortfolio
                ? formatText(
                      'raSuitabilityTest-testFailureDisclaimer_contentCC1',
                  )
                : formatText(
                      'raSuitabilityTest-testFailureDisclaimer_contentCCNoPortfolio1',
                  );

            const secondParagraphCC = hasRoboPortfolio
                ? formatText(
                      'raSuitabilityTest-testFailureDisclaimer_contentCC2',
                  )
                : formatText(
                      'raSuitabilityTest-testFailureDisclaimer_contentCCNoPortfolio2',
                  );
            content = (
                <div className="ra-suitability-test-failure-disclaimer__content ra-suitability-test-failure-disclaimer__content">
                    <BlockInfo>
                        <div className="ra-suitability-test-failure-disclaimer__content-cc">
                            <p>{firstParagraphCC}</p>
                            <p>{secondParagraphCC}</p>
                        </div>
                    </BlockInfo>
                </div>
            );
        } else {
            const secondParagraph = hasRoboPortfolio
                ? formatText(
                      'raSuitabilityTest-testFailureDisclaimer_contentPortfolio',
                  )
                : formatText(
                      'raSuitabilityTest-testFailureDisclaimer_contentNoPortfolio',
                  );
            content = (
                <div className="ra-suitability-test-failure-disclaimer__content">
                    <p>
                        <FormattedText value="raSuitabilityTest-testFailureDisclaimer_content1" />
                    </p>
                    <p> {secondParagraph} </p>
                </div>
            );
        }
        return content;
    }

    render() {
        const { hasRoboPortfolio, modalIsOpen } = this.props;
        const content = this.buildContent();
        const secondaryButtonLabel = hasRoboPortfolio
            ? formatText(
                  'raSuitabilityTest-testFailureDisclaimer_buttonPortfolio',
              )
            : formatText(
                  'raSuitabilityTest-testFailureDisclaimer_buttonMyInvestments',
              );
        const secondaryButton =
            __CONTACT_CENTER__ && hasRoboPortfolio ? (
                <OKButton
                    modifier="secondary"
                    onClick={this.handleContinueWithUnsuccessTest}
                >
                    <FormattedText value="raSuitabilityTest-testFailureDisclaimer_buttonContinueCC" />
                </OKButton>
            ) : (
                <OKButton
                    modifier="secondary"
                    onClick={this.handleSecondaryButton}
                >
                    {secondaryButtonLabel}
                </OKButton>
            );
        return (
            <div className="ra-suitability-test-failure-disclaimer">
                <RASuitabilityTestFailureDisclaimerModal
                    modalIsOpen={modalIsOpen}
                    onHandleReviseSuitabilityTest={
                        this.handleReviseSuitabilityTest
                    }
                />
                <div className="row ra-suitability-test-failure-disclaimer__row">
                    <div className="col-xs-8">
                        <ContentBox customClassName="ra-suitability-test-failure-disclaimer__container">
                            <div className="ra-suitability-test-failure-disclaimer__icon-container">
                                <i className="ra-suitability-test-failure-disclaimer__icon" />
                            </div>
                            <div className="ra-suitability-test-failure-disclaimer__title">
                                <FormattedText value="raSuitabilityTest-testFailureDisclaimer_title" />
                            </div>
                            {content}
                            <div className="ra-suitability-test-failure-disclaimer__button-zone">
                                <div className="ra-suitability-test-failure-disclaimer__button-portfolio">
                                    {secondaryButton}
                                </div>
                                <div className="ra-suitability-test-failure-disclaimer__button-review-test">
                                    <OKButton
                                        modifier="primary"
                                        onClick={
                                            this.handleReviseSuitabilityTest
                                        }
                                    >
                                        <FormattedText value="raSuitabilityTest-testFailureDisclaimer_buttonReviewTest" />
                                    </OKButton>
                                </div>
                            </div>
                        </ContentBox>
                    </div>
                </div>
            </div>
        );
    }
}

RASuitabilityTestFailureDisclaimer.propTypes = {
    history: PropTypes.object.isRequired,
    modalIsOpen: PropTypes.bool,
    hasRoboPortfolio: PropTypes.bool,
    resetTestCompleted: PropTypes.func,
    isReviewInProgress: PropTypes.func,
    continueWithUnsuccess: PropTypes.func.isRequired,
};

module.exports = withRouter(RASuitabilityTestFailureDisclaimer);
